/**
 * dashboard/data-method-url.js — делегирование кликов на AJAX по data-method / data-url.
 * Зависит от внутренних функций проекта: window.showToast(msg, type), window.openConfirmModal({ message, callback }).
 */
window.dataMethodUrl = function (btnClass, callback, beforeAjax) {
    let classSelector = String(btnClass || "").trim();
    if (!classSelector) {
        return;
    }
    if (!classSelector.startsWith(".")) {
        classSelector = "." + classSelector;
    }

    let comp = ["a", "button"];
    let selector = comp.map(function (tag) {
        return tag + classSelector + "[data-method]";
    }).join(", ");

    jQuery(document).off("click.dmHandler", selector).on("click.dmHandler", selector, function (e) {
        e.preventDefault();

        let element = jQuery(this);
        let url = element.attr("data-url") || element.attr("href");
        let method = element.attr("data-method") || "POST";
        let question = element.attr("data-question");

        let runAjax = function () {
            let ajaxSettings = {
                url: url,
                type: method,
                success: function (response) {
                    if (typeof callback === 'function') {
                        callback.call(element, response);
                    }
                },
                error: function (xhr) {
                    let message = 'Системная ошибка. Попробуйте позже.';
                    let json = xhr.responseJSON;

                    if (json) {
                        if (json.message) {
                            message = json.message;
                        }
                        if (json.errors && typeof json.errors === 'object') {
                            let firstKey = Object.keys(json.errors)[0];
                            let firstMsg = firstKey && json.errors[firstKey] && json.errors[firstKey][0];
                            if (firstMsg) {
                                message = firstMsg;
                            }
                        }
                    }

                    if (window.showToast) {
                        window.showToast(message, 'error');
                    }
                }
            };

            if (typeof beforeAjax === 'function') {
                let prepared = beforeAjax.call(element, ajaxSettings, element);
                if (prepared === false) {
                    return;
                }
            }

            jQuery.ajax(ajaxSettings);
        };

        if (question) {
            if (typeof window.openConfirmModal === 'function') {
                // Здесь теги сработают через .html() внутри openConfirmModal
                window.openConfirmModal({
                    message: question,
                    callback: runAjax
                });
            } else {
                // Подготовка текста для системного confirm:
                // 1. Заменяем <br> и <br/> на перенос строки \n
                // 2. Удаляем все остальные HTML теги
                let plainText = question
                    .replace(/<br\s*\/?>/gi, '\n')
                    .replace(/<\/?[^>]+(>|$)/g, "");

                if (confirm(plainText)) {
                    runAjax();
                }
            }
        } else {
            runAjax();
        }
    });
};
